import React from 'react'
import { Link, usePage } from '@inertiajs/inertia-react'
import Breadcrumbs from '../../Shared/Components/Breadcrumbs'
import Layout from '../../Shared/Layout/LayoutAdmin'
import { aboutUsSectionUrl } from '../../utils/aboutUsPermissions'
import './about-us.css'

function PhotoBox({ url, alt, className = '' }) {
    if (url) {
        return <img src={url} alt={alt} className={'about-us-photo ' + className} />
    }

    return (
        <div className={'about-us-photo about-us-photo--empty ' + className}>
            <i className="bi bi-image fs-2x text-gray-400"></i>
        </div>
    )
}

function Content({ html }) {
    if (!html) {
        return <p className="text-muted fst-italic mb-0">Contenido pendiente de publicar.</p>
    }

    return <div className="about-us-content" dangerouslySetInnerHTML={{ __html: html }} />
}

const Show = ({ section, related, canEdit }) => {
    const { url } = usePage()
    const currentPath = String(url || '').split('?')[0]

    return (
        <div className="about-us">
            <span className="d-block pb-7 pt-7">
                <Breadcrumbs currentPath={currentPath} />
            </span>

            <div className="card card-flush shadow-sm about-us-card mb-8">
                <div className="card-header pt-7 border-0">
                    <h2 className="card-title fw-bold text-gray-800 text-uppercase fs-3 m-0">{section.title}</h2>
                    {canEdit && (
                        <div className="card-toolbar">
                            <Link
                                href={route('about-us.manage', { tab: section.slug })}
                                className="btn btn-sm btn-light-primary"
                            >
                                <i className="bi bi-pencil-square me-1"></i> Editar
                            </Link>
                        </div>
                    )}
                </div>
                <div className="card-body pt-4">
                    {section.layout === 'stacked' ? (
                        <div className="about-us-scroll">
                            <PhotoBox url={section.photo_url} alt={section.title} className="about-us-photo--banner mb-7" />
                            <Content html={section.content} />
                        </div>
                    ) : (
                        <div className="row g-8">
                            <div className="col-md-5">
                                <PhotoBox url={section.photo_url} alt={section.title} className="about-us-photo--side" />
                            </div>
                            <div className="col-md-7">
                                <div className="about-us-scroll">
                                    <Content html={section.content} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {related.length > 0 && (
                <div className="row g-6 mb-10">
                    {related.map((item) => (
                        <div className="col-md-6" key={item.slug}>
                            <Link href={aboutUsSectionUrl(item.slug)} className="about-us-link-card shadow-sm">
                                {item.photo_url ? (
                                    <img src={item.photo_url} alt={item.title} className="about-us-link-card__thumb" />
                                ) : (
                                    <span className="about-us-link-card__accent"></span>
                                )}
                                <span className="about-us-link-card__title">{item.title}</span>
                            </Link>
                        </div>
                    ))}
                </div>
            )}
        </div>
    )
}

Show.layout = (page) => <Layout title={`Quiénes somos — ${page.props.section.title}`}>{page}</Layout>

export default Show
